module.exports = __webpack_public_path__ + "img/arrow_right.d1078a61.svg";